export default __webpack_public_path__ + "static/media/Profile-filled.209922f0.svg";